import PagePremission from '@/routes/Restrictions/PagePremission';
import TargetTeleSalesPermission from '@/utils/premissions/TargetTeleSalesPermission.enum';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const TargetSales = lazy(() => import('@/pages/TargetSales/TargetSales'));
const RetailTeleSales = lazy(() =>
  import('@/pages/TargetTeleSales').then(m => ({ default: m.RetailTeleSales }))
);
const WholesaleTeleSales = lazy(() =>
  import('@/pages/TargetTeleSales').then(m => ({ default: m.WholesaleTeleSales }))
);

const TargetSalesRoute: RouteObject[] = [
  {
    path: ':type',
    element: (
      <PagePremission
        prem={TargetTeleSalesPermission.Prem_Target_Tele_Sales_View}
      >
        <TargetSales />
      </PagePremission>
    ),
  },
];

// TeleSales Routes - Direct access to retail and wholesale
export const TargetTeleSalesRoute: RouteObject[] = [
  {
    path: 'retail',
    element: (
      <PagePremission
        prem={TargetTeleSalesPermission.Prem_Target_Tele_Sales_Manage_All_Retail}
      >
        <RetailTeleSales />
      </PagePremission>
    ),
  },
  {
    path: 'wholesale',
    element: (
      <PagePremission
        prem={TargetTeleSalesPermission.Prem_Target_Tele_Sales_Manage_All_WholeSale}
      >
        <WholesaleTeleSales />
      </PagePremission>
    ),
  },
];

export default TargetSalesRoute;
